 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A7813984877272 from '@/components/97813984877272'
 import A7813984877273 from '@/components/97813984877273'
 import A7813984877274 from '@/components/97813984877274'
 import A7813984877275 from '@/components/97813984877275'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
		{
 			"path" : "/",
 			"name" : "home",
 			"components" : {
				default: Home
			}
 		},
 		{
 			"path" : "/tcpage1",
 			"name" : "tcpage1"
 			,"components" : {
				 left: A7813984877272
				 ,
				 right: A7813984877273
			}
 		},
 		{
 			"path" : "/tcpage2",
 			"name" : "tcpage2"
 			,"components" : {
				 left: A7813984877274
				 ,
				 right: A7813984877275
			}
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"components" : {
				default: Last
			}
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js